/**
 * Lien vers Paramètres commerçant → onglet Caisses (CORE-OPS-3A/3C).
 * Route réelle : CommercantDetail `/commercants/:id?tab=parametres&settingsTab=caisses`
 */
export function buildCommercantCaissePostesSettingsHref(commercantId) {
  if (!commercantId) return '/commercants';
  const params = new URLSearchParams({
    tab: 'parametres',
    settingsTab: 'caisses',
  });
  return `/commercants/${encodeURIComponent(String(commercantId))}?${params.toString()}`;
}
